/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {WizardComponent} from './wizard.component';
import {WizardHeaderComponent} from './wizard-header.component';
import {WizardService} from './wizard.service';
import {WizardFooterComponent} from './wizard-footer.component';
import {TooltipModule} from '../tooltip/tooltip.module';

@NgModule({
    imports: [
        CommonModule,
        TooltipModule,
    ],
    declarations: [WizardComponent, WizardHeaderComponent, WizardFooterComponent],
    exports: [WizardComponent],
    providers: [WizardService]
})
export class WizardModule {
}
